import MuiTooltip from '@material-ui/core/Tooltip';

export default MuiTooltip;
